import React from "react";
import { useEffect } from "react";
import { Outlet, Navigate } from "react-router-dom";

const PrivateRoute = ({ children, ...rest }) => {
  return localStorage.getItem("id") ? <Outlet /> : <Navigate to={"/signin"} />;
};

export default PrivateRoute;
